export const POSITION_VALUE_LIST = [
  'absolute',
  'relative',
  'fixed',
  'sticky',
]

export const NORMAL_ANIMATION_DURATION = 300
